module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about",
    style: ({
      height: _vm.height
    })
  }, [_c('b-header'), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "container",
    on: {
      "mousewheel": _vm.mousewheel,
      "wheel": _vm.mousewheel
    }
  }, [_c('div', {
    ref: "about",
    staticClass: "page",
    style: ({
      height: _vm.height,
      overflowY: 'scroll',
      paddingBottom: '20px'
    }),
    on: {
      "mousewheel": function($event) {
        $event.stopPropagation();
        return _vm.mousewheel_about.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [(_vm.animateCtrl[0]) ? _c('div', {
    staticClass: "line"
  }) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "right-in"
    }
  }, [(_vm.animateCtrl[0]) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].aboutTItle1))]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "bottom-in-delay"
    }
  }, [(_vm.animateCtrl[0]) ? _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.turnToA(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].aboutTItle1))])]) : _vm._e()])], 1), _c('div', {
    staticClass: "page page_about_1"
  }, [_c('div', {
    staticClass: "imgs"
  }, [_c('div', {
    staticClass: "img"
  }), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "mask"
  }, [_c('transition', {
    attrs: {
      "name": "bottom-in"
    }
  }, [(_vm.animateCtrl[0]) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].aboutTItle1))]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [(_vm.animateCtrl[0]) ? _c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].aboutDetail1))]) : _vm._e()])], 1)])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b25446dc","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about.vue
// module id = 516
// module chunks = 1